import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to royally cock up as a freelancer",
  "description": "",
  "published": "2014-05-06T00:00:00.000Z",
  "redirect_from": ["/blog/how-to-royally-cock-up-as-a-freelancer/swizec/6570"],
  "categories": "Bank account, Business, Clients, Freelancer, Freelancing, Silicon Valley, Slovenia, United States",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "650px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/7c0064bc4052ba04a9a73865044d38f0/6aca1/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.95515695067265%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'280\\'%20viewBox=\\'0%200%20400%20280\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M104%20132c0%2010%200%2010-3%2011-3%200-3%206%201%207%202%200%202%201%202%204s0%203%202%203c3%200%203%200%203-4l1-4%207-2c9-1%209-1%209%205-1%205-1%205%202%205s3%200%203-6l1-6%201%204c0%206%201%208%203%208s3%200%202-6c0-7%200-7%207-8h5v14h6c5%200%205%200%205-2%200-3%200-3-3-3s-3%200-3-5v-5l6-1c12-2%2012-2%2011%207v9h6c6%200%206%200%205-2%200-2-1-3-3-3-3%200-3-9%200-10l2-2c0-1%200-2%202-2%203%200%203-1%202-4%200-3-1-3-4-3h-4v-2l3-1c2%200%202-1%203-3%200-2%200-2-6-2h-6v4c1%205%201%205-7%206l-8%202c-2%200-2%200-2-3%200-4%200-4%203-4s3%200%203-2c0-3%200-3-5-3h-6v13h-5c-7%201-7%202-7-4%200-7-2-9-8-9l-4%201v7c0%208%200%208-8%209-4%201-5%201-5-1l-2-2c-3-1-3-9%200-9s4-1%203-3c0-2-1-2-5-2h-5v9m91%208v17h5c5%200%205%200%205-2s0-3-2-3h-3v-29h-5v17m24-16a927%20927%200%2001-4%2032l2%201c2%200%203-1%203-3%201-3%203-4%203%200%200%202%201%203%203%203%203%200%203%200%203-4l-4-29h-6m21%2016c0%2016%200%2017%202%2017s2-1%202-9l1-9%202%209c2%208%202%209%205%209h2v-17c-1-16-1-17-3-17s-2%200-2%209v9l-2-9c-2-8-3-9-5-9h-2v17m27-15c-2%202-2%206-2%2016%200%2012%200%2012%202%2015%205%204%2011%201%2011-6%200-4%200-5-2-5-1%200-2%201-2%204l-2%204-1-13c0-12%200-13%202-12l1%202c0%204%200%205%202%205s3-7%201-10-8-3-10%200m23%200v31l6%201c5%200%205%200%205-2%200-3%200-3-3-3s-3%200-3-5c0-4%200-5%202-5l2-2-2-3c-2%200-2-1-2-5s0-4%203-4%203%200%203-2c-1-3-10-4-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7c0064bc4052ba04a9a73865044d38f0/ca0a1/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.webp 223w", "/static/7c0064bc4052ba04a9a73865044d38f0/75680/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.webp 445w", "/static/7c0064bc4052ba04a9a73865044d38f0/c1dc5/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.webp 650w"],
                "sizes": "(max-width: 650px) 100vw, 650px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7c0064bc4052ba04a9a73865044d38f0/853b2/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.jpg 223w", "/static/7c0064bc4052ba04a9a73865044d38f0/0a4fe/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.jpg 445w", "/static/7c0064bc4052ba04a9a73865044d38f0/6aca1/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.jpg 650w"],
                "sizes": "(max-width: 650px) 100vw, 650px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7c0064bc4052ba04a9a73865044d38f0/6aca1/Photo-borrowed-without-permission-from-Marc-Kodis-because-I-cant-find-contact-infog069ej.jpg",
                "alt": "Photo borrowed without permission from Marc Kodis because I can't find contact info",
                "title": "Photo borrowed without permission from Marc Kodis because I can't find contact info",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Photo borrowed without permission from Marc Kodis because I can't find contact info`}</figcaption>{`
  `}</figure></p>
    <p>{`I've been working for a single client since June. They're awesome! Pay well, pay on time, easy to talk to, the work is interesting. Everything you'd want in a client.`}</p>
    <p>{`But three months ago their business changed and their need for a web generalist dwindled. Our relationship calmed down to just two days a week.`}</p>
    <p><em parentName="p">{`"Great!"`}</em>{`, I thought, `}<em parentName="p">{`"I'll take it easy for a while! Plenty of money in the bank, and I could use a break. Been working pretty hard the past few months"`}</em>{`.`}</p>
    <p>{`Went back to Slovenia for two months. Took it easy. Spent a lot of time with friends. Spent even more time recovering from hangovers. Did a butt-tonne of sports.`}</p>
    <p>{`Life was grand.`}</p>
    <p>{`Did a few tiny writing gigs next to the two days a week of Real Work (tm) because, hey, people asked and I had free time. But I wasn't serious about looking for clients.`}</p>
    <p>{`The Client will surely need me for a more reasonable number of days in two months. We've loosely agreed to it! There was even a handshake! Wait ... no, there was no handshake.`}</p>
    <p>{`A week before going back to on-site I was informed that our arrangement would continue at two days a week. There simply isn't enough web development work to go around.`}</p>
    <p>{`Well, fuck.`}</p>
    <p>{`But hey, coffers are still pretty full. No biggie. I'll just find other clients when I'm in the US. How hard can it be?`}</p>
    <p>{`And then April happened.`}</p>
    <p>{`Known to grown ups unlike myself as Taxes Month. Slovenia wanted just over €5000 for my sins of saving rather than spending money. Next to my regular monthly sacrifice to the Slovenian social system, of course.`}</p>
    <p>{`After paying rent and buying a plane ticket, my bank account only had some €4000 left.`}</p>
    <p>{`Fuck ...`}</p>
    <p>{`The astute reader will notice this was almost €2000 short of what I would have to pay by mid-month. Essentially I've made 15k this year, and in April 10k went `}{`*`}{`poof`}{`*`}{`.`}</p>
    <p>{`Did I mention I hadn't been grooming my work pipeline since early last year because I was really busy and very happy with my clients?`}</p>
    <p>{`How do people get new work again?`}</p>
    <p>{`Panic mode. I can delay paying the government by a few days or weeks because they're a huge bureaucracy and won't even notice, but my bank made me sign a few scary-looking blank checks in return for that credit card. Brown underpants time!`}</p>
    <p>{`Sent an email everyone I could find on HN's monthly freelancer thread. Pinged every one in my network I could think of.`}</p>
    <p>{`Nothing.`}</p>
    <p>{`A week went by. I had a few calls with potential clients, nothing solid.`}</p>
    <p>{`Another week passed. An old client of mine remembered me. We quickly made a deal and I collected the customary 50% in advance. It's now been 3 weeks and I finally got the full specs for the job. Will probably get the other 50% at the end of May, or later.`}</p>
    <p>{`Turns out that while Silicon Valley is absolutely brimming with opportunity and everyone is looking for programmers, actually getting work is insanely hard.`}</p>
    <p>{`It's not that I wasn't good enough. Or that I didn't jibe with most of the potential clients.`}</p>
    <p>{`It's that everyone wants you to work full-time. Even when they're okay with contracting, they want it to be full-time. Five days a week. What do you mean you only have three days of time?`}</p>
    <p>{`Suddenly that awesome client of mine that I really love working with turned into a huge liability. I imagine it's a bit like dating with a huge wart over half of your face. An unnecessary handicap.`}</p>
    <p>{`Somebody even said `}<em parentName="p">{`"We want to marry you. It doesn't have to be right away, but eventually you have to be ours. Completely and utterly. Ours."`}</em></p>
    <p>{`Yup.`}</p>
    <p>{`But on Friday everything coalesced. My standards had been beaten low enough. My will was broken. I would take pretty much anything I could get. I had three meetings with potential clients.`}</p>
    <p>{`Loved the first one, but their process looked long-ish and I was pressed for time. Signed an unfavourable deal with the second one. Third one told me it's a shame I signed not an hour ago because they wanted to give me a better deal.`}</p>
    <p>{`Alas.`}</p>
    <p>{`But hey, I am back to being fully booked. It's not ideal, it's on a trial basis (my trial of them), but it extends my runway by a month and I can look for better clients in peace. No more worrying about pesky little things like staying alive and not having my kneecaps broken by goons.`}</p>
    <p>{`Naturally, The Client asked if I have more than two days of time this week ...`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=afa3c729-d1c1-4677-bfe9-b9c686f02ef6",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      